import { ExternalLink } from "lucide-react";

const newsItems = [
  {
    source: "Economic Times - Hospitality",
    title: "Kiplings debuts in Hyderabad bringing the charm of a European deli bistro",
    excerpt: "The European-inspired deli and bistro concept has opened at Level 4, Inorbit Mall, Hyderabad, bringing artisan bakery, fine dining, and gourmet coffee to the city.",
    url: "https://hospitality.economictimes.indiatimes.com/news/restaurants/kiplings-debuts-in-hyderabad-bringing-the-charm-of-an-european-deli-bistro/132528812",
    date: "2025",
  },
  {
    source: "Hospitality Biz India",
    title: "Kiplings: A Slice of Europe",
    excerpt: "A contemporary deli and bistro bringing together artisanal baking and global comfort. Kiplings offers a unique European marketplace experience in Hyderabad.",
    url: "https://hospitalitybizindia.com/fb/kiplings-a-slice-of-europe/",
    date: "2025",
  },
  {
    source: "Swiggy Dineout",
    title: "Rated 4.7/5 on Swiggy Dineout",
    excerpt: "Kiplings Deli and Bistro at Madhapur, Hyderabad has earned a 4.7 out of 5 rating from diners praising the croissants, coffee, ambience, and attentive service.",
    url: "https://www.swiggy.com/restaurants/kiplings-d-li-and-bistro-madhapur-hyderabad-1383272/dineout",
    date: "2025",
  },
  {
    source: "District",
    title: "Rated 4.1/5 on District with rave reviews",
    excerpt: "Diners praise the croissants, specialty coffee, elegant ambience and the overall European bistro feel that Kiplings brings to Hitech City, Hyderabad.",
    url: "https://www.district.in/dining/hyderabad/kiplings-d%C3%A9li-bistro-hitech-city",
    date: "2025",
  },
];

export const NewsSection = () => {
  return (
    <section id="news" className="py-24 md:py-32 bg-[#EEE8DC]" data-testid="news-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-[#C9A85A] text-sm tracking-[0.2em] uppercase font-body font-semibold mb-3">
            In the Press
          </p>
          <h2 className="font-heading text-4xl md:text-5xl text-[#191646] font-medium tracking-tight mb-4">
            Kiplings in the News
          </h2>
          <p className="text-[#4A5568] font-body max-w-lg mx-auto">
            What people are saying about us.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {newsItems.map((item, index) => (
            <a
              key={index}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`news-item-${index}`}
              className="group block bg-white border border-[#DDD6C8] p-6 md:p-8 hover:border-[#C9A85A] hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start justify-between gap-4 mb-3">
                <span className="text-[#C9A85A] text-xs font-body font-semibold tracking-wider uppercase">
                  {item.source}
                </span>
                <ExternalLink size={14} className="text-[#4A5568]/40 group-hover:text-[#C9A85A] transition-colors flex-shrink-0 mt-0.5" />
              </div>
              <h3 className="font-heading text-lg text-[#191646] font-medium mb-2 group-hover:text-[#C9A85A] transition-colors">
                {item.title}
              </h3>
              <p className="text-[#4A5568] text-sm font-body leading-relaxed line-clamp-2">
                {item.excerpt}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
